import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as string | null;

const slice = createSlice({
  name: '$mobileRegexWhitelist',
  initialState,
  reducers: {
    setMobileRegexWhitelist(state, action: PayloadAction<string | null>) {
      return action.payload;
    },
  },
});

export const { setMobileRegexWhitelist } = slice.actions;
export default slice.reducer;
